import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';
import { aggregatedClasses } from '@elliemae/ds-classnames';

var blockName = 'tabs-panels';
var PC = aggregatedClasses('div')(blockName, 'panel');

var PanelContainer = function PanelContainer(_ref) {
  var children = _ref.children,
      lastTabRef = _ref.lastTabRef,
      firstSubtabRef = _ref.firstSubtabRef,
      rest = _objectWithoutProperties(_ref, ["children", "lastTabRef", "firstSubtabRef"]);

  // inject ref to handle focus on first subtab child
  var child = React.Children.map(children, function (c, i) {
    return i === 0 && c ? /*#__PURE__*/React.cloneElement(c, {
      firstSubtabRef: firstSubtabRef,
      lastTabRef: lastTabRef
    }) : c;
  });
  return /*#__PURE__*/React.createElement(PC, rest, child);
};

PanelContainer.propTypes = {
  children: PropTypes.any,
  firstSubtabRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  lastTabRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })])
};

export default PanelContainer;
//# sourceMappingURL=PanelContainer.js.map
